<template>
	<keep-alive :include="include">
		<router-view />
	</keep-alive>
</template>


<script>
	export default {
		name: 'group-layout',
		data() {
			return {
				include: ['group-settings']
			};
		}
	};
</script>
